import s from './timezone-modal.module.scss'
import { Modal } from '@shared/ui/modal/modal';
import { FetchingDiv } from '@shared/ui/fetching-div/fetching-div';
import { useProfile } from '@shared/api/useProfile';
import { Button } from '@shared/ui/button/button';
import { useState } from 'react';
import { useUpdateProfile } from '@shared/api/useUpdateProfile';
import { useTimezoneModal } from '../../model/use-timezone-modal';
import { TimezonePicker } from '@entities/profile/ui/timezone-picker/timezone-picker';

export const TimezoneModal = () => {
	const {isOpen, close} = useTimezoneModal()
	
	const {data: profile, isLoading} = useProfile()
	const [selected, setSelected] = useState(null)
	const { mutate: updateProfile } = useUpdateProfile();

  return (
		<Modal style={{
			content: {
				overflow: 'visible',
			}
		}} {...{isOpen, close}} title={'Выберите ваш часовой пояс'}>
			<FetchingDiv className={s.card} isFetching={isLoading}>
					<span className={s.caption}>
						Это нужно, чтобы показывать расписание занятий по вашему времени
					</span>
					<TimezonePicker currentTz={profile?.timezone} {...{selected, setSelected}}/>
					<Button label="Сохранить" className={s.btn} onClick={() => {
						updateProfile({
							timezone: selected?.value
						})
						close()
					}}/>
			</FetchingDiv>
		</Modal>
  );
}